"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const EtudeError_1 = require("../error/EtudeError");
const Value_1 = require("./Value");
class Tempo {
    constructor(bpm, parameterA = Value_1.default.QUARTER, parameterB = (`[${parameterA}] = ${bpm}`)) {
        this.bpm = bpm;
        if (parameterA instanceof Value_1.default) {
            this.beatValue = parameterA;
            this.tempoMarking = parameterB;
        }
        else if (typeof parameterA === "string") {
            if (arguments.length !== 2) {
                throw EtudeError_1.default.forIllegalArgument(Tempo, parameterA, "Invalid number of arguments");
            }
            this.beatValue = Value_1.default.QUARTER;
            this.tempoMarking = parameterA;
        }
    }
    getBPM() {
        return this.bpm;
    }
    getBeatValue() {
        return this.beatValue;
    }
    getTempoMarking() {
        return this.tempoMarking;
    }
}
/*
 * Values based on the mean of the values given in
 * https://en.wikipedia.org/wiki/Tempo
 */
Tempo.LARGHISSIMO = new Tempo(24, "Larghissimo");
Tempo.GRAVE = new Tempo(35, "Grave");
Tempo.LARGO = new Tempo(50, "Largo");
Tempo.LENTO = new Tempo(53, "Lento");
Tempo.LARGHETTO = new Tempo(63, "Larghetto");
Tempo.ADAGIO = new Tempo(71, "Adagio");
Tempo.ADAGIETTO = new Tempo(74, "Adagietto");
Tempo.ANDANTE = new Tempo(92, "Andante");
Tempo.ANDANTINO = new Tempo(94, "Andantino");
Tempo.MARCIA_MODERATO = new Tempo(84, "Marcia Moderato");
Tempo.ANDANTE_MODERATO = new Tempo(102, "Andante Moderato");
Tempo.MODERATO = new Tempo(114, "Moderato");
Tempo.ALLEGRETTO = new Tempo(116, "Allegretto");
Tempo.ALLEGRO_MODERATO = new Tempo(118, "Allegro Moderato");
Tempo.ALLEGRO = new Tempo(144, "Allegro");
Tempo.VIVACE = new Tempo(172, "Vivace");
Tempo.VIVACISSIMO = new Tempo(174, "Vivacissimo");
Tempo.ALLEGRISSIMO = new Tempo(174, "Allegrissimo");
Tempo.ALLEGRO_VIVACE = new Tempo(174, "Allegro Vivace");
Tempo.PRESTO = new Tempo(184, "Presto");
Tempo.PRESTISSIMO = new Tempo(200, "Prestissimo");
exports.default = Tempo;
